module.exports = __webpack_public_path__ + "img/video.c0fcb2c8.png";